import type { Pathnames } from "next-intl/routing";

export const EN = "en";
export const ZH_CN = "zh-CN";
export const ZH_HK = "zh-HK";

export const localeNames = {
	[EN]: "English",
	// [ZH_CN]: "简体中文",
	[ZH_HK]: "繁體中文",
} as Record<string, string>;

export const defaultLocale = EN;

// 所有语言列表的标识代码，不含具体语言名称
export const locales = [
	EN,
	// ZH_CN,
	ZH_HK,
];

export const pathnames: Pathnames<typeof locales> = {
	// "/": {
	// 	[EN]: "/",
	// 	[ZH_CN]: "/zh-CN",
	// 	[ZH_HK]: "/zh-HK",
	// }
};

export type I18nLocales = { key: string; name: string }[];

export const getCurrentLocaleName = (locale: string) => {
	return localeNames[locale];
};

// 生成多语言的alternates
export function alternatesLanguage(subPath: string) {
	const path = process.env.UE_WEB_URL;
	const languages: Record<string, string> = {};
	for (const lang of locales) {
		languages[lang] =
			lang === defaultLocale
				? `${path}${subPath}`
				: `${path}/${lang}${subPath}`;
	}
	return languages;
}

export function alternatesCanonical(
	locale: string,
	subPath: string,
	page?: string
) {
	const path = process.env.UE_WEB_URL;
	const withPages = page ? `/${page}` : "";
	return `${path}${defaultLocale === locale ? "" : `/${locale}`}${subPath}${withPages}`;
}

export const port = process.env.PORT || 8000;
export const host = process.env.UE_WEB_URL
	? `https://${process.env.UE_WEB_URL}`
	: `http://localhost:${port}`;
